import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * BM-H393: a redirect that keeps the query string and hash.
 *
 * React Router's <Navigate to="/somewhere" /> discards everything after the
 * path. That is fine for a redirect to a login screen, and wrong for an alias
 * route, because an alias is supposed to be the same destination reached by an
 * older name.
 *
 * /conflict-check was aliased to /conflict-search with a bare Navigate. Four
 * places in the app link to it with parameters:
 *
 *   NewMatter          /conflict-check?submission_id=...&return_to=/new-matter
 *   PipelineTrackerCore /conflict-check?matter=<ref>   (two call sites)
 *   HomeScreen          /conflict-check?matter=<ref>
 *
 * (BM-H3263: the pipeline and HomeScreen now reach this only through
 * utils/openConflictCheck, and only when a row has no conflict check yet.)
 *
 * and ConflictsSearch prefills six form fields from the query string
 * (source_quote_ref, client_name, client_email, matter_description,
 * fee_earner_initials, estimated_fee). So every one of those links arrived at
 * a blank form, and whoever clicked it retyped what the app already knew. No
 * error, nothing in a log, just silent extra work.
 *
 * Use this for alias and rename redirects. Keep the plain <Navigate> for
 * redirects that deliberately drop context, such as bouncing to /login.
 */
export default function PreserveQueryNavigate({ to, replace = true }) {
  const location = useLocation();
  const search = location.search || "";
  const hash = location.hash || "";
  return <Navigate to={`${to}${search}${hash}`} replace={replace} />;
}
